export default [
  {
    title: "What Are Cookies",
    body: "Cookies are small data files stored on your device that help improve your experience on our website.",
  },
  {
    title: "Use of Cookies",
    body: "We use cookies to understand how you use our site and to improve your experience. This includes personalizing content and advertising.",
  },
  {
    title: "Managing Cookies",
    body: "You have the right to accept or reject cookies. Most web browsers automatically accept cookies, but you can usually modify your browser setting to decline cookies if you prefer.",
  },
];
